<cpq-select #selectDomain [label]="{key: 'Login.Domain'}"
            [type]="selectType.Searchable"
            [items]="domains"
            [(ngModel)]="currentSelectedDomain"
            (click)="clearSelectedDomain()"
            (ngModelChange)="onDomainChange($event)"
            (focusout)="focusout($event)">
</cpq-select>